export default function getLoadBalancersReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_LOAD_BALANCERS_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_LOAD_BALANCERS_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_LOAD_BALANCERS_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}